import CoreuiController from "../lib/coreui-controller"
import DateRangePicker from "../coreui/date-range-picker"

export default class CoreuiDateRangePickerController extends CoreuiController {
  static Component = DateRangePicker
}
